import { Image, isWeb, XStack } from '@mythical/ui'
import { RenderBlocks } from 'app/components/blocks/RenderBlocks'
import { ButtonLink } from 'app/components/primitive/Button'
import { Meta } from 'app/components/primitive/Meta'
import Spinner from 'app/components/primitive/Spinner'
import { Container } from 'app/components/structure/Container'
import MainLayout from 'app/components/structure/Layout/MainLayout'
import Section from 'app/components/structure/Section'
import { ALL_ACCESS_TIER } from 'app/constants/tiers'
import useQuery from 'app/hooks/use-query'
import { createCollectiblePageQuery } from 'app/queries/collectibles/single'
import { useStores } from 'app/store'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { createParam } from 'solito'

const query = createCollectiblePageQuery()
const { useParam } = createParam<{ slug: string }>()

interface CollectibleScreenProps {
  slug: string
}

export const CollectibleScreen = observer<CollectibleScreenProps>((props) => {
  const { userStore } = useStores()
  const canMemberfulLink = userStore?.canMemberfulLink ?? false
  const [slug] = useParam('slug')
  const [params, setParams] = useState({ slug: props.slug || slug })

  useEffect(() => {
    setParams({ slug })
  }, [slug])

  const { loading, data } = useQuery(query.query, params, query.mapToPage, {
    refetchOnMount: 'always',
    staleTime: 0,
  })

  const { title, quarter, pageContent, terms, heroImage } = data || {}
  const isEligible = userStore?.user?.tier !== ALL_ACCESS_TIER.name
  return (
    <MainLayout
      noFooter
      showBackBtn
      contentStyles={{
        bg: '$bgPrimary',
      }}
    >
      {title && <Meta title={title} type="collectible" slug={slug} />}
      <Section paddedX bg="$bgPrimary" ai="center" space="$5" spaciousBottom>
        {loading && <Spinner pt="$3" size="large" />}
        {heroImage && (
          <Container
            variant="mediumLarge"
            overflow="hidden"
            borderRadius="$3"
            {...(isWeb ? { pb: '56.25%' } : { aspectRatio: 16 / 9 })}
          >
            <Image
              source={{ uri: heroImage }}
              width="100%"
              height="100%"
              pos={isWeb ? 'absolute' : 'relative'}
            />
          </Container>
        )}
        {pageContent && (
          <Container variant="mediumLarge">
            <RenderBlocks
              blocks={pageContent}
              slug={slug}
              textProps={{
                textAlign: 'center',
                size: '$5',
              }}
              spaced
            />
          </Container>
        )}
        {canMemberfulLink && isEligible && (
          <XStack flexWrap="wrap" jc="center">
            <ButtonLink m="$2" href="/perks?tier=2&frequency=quarterly">
              Join All Access Quarterly
            </ButtonLink>
            <ButtonLink m="$2" href="/perks?tier=2&frequency=annually">
              Join All Access Annual
            </ButtonLink>
          </XStack>
        )}
        {terms && (
          <Container variant="mediumLarge">
            <RenderBlocks
              blocks={terms}
              textProps={{
                textAlign: 'center',
                size: '$3',
                fontWeight: '300',
              }}
              spaced
            />
          </Container>
        )}
      </Section>
    </MainLayout>
  )
})
